import React, { PureComponent } from 'react';
import { Form } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { SemanticFormField } from './SemanticFormField';
import { getValidations } from '../helpers/validationByFieldType';

// components

class TermsOfService extends PureComponent {
  render() {
    const IsGermanShoreShow = process.env.REACT_APP_IS_GERMAN_SHORE_SHOW === 'true';
    return (
      <Form>
        <Field
          name="termsOfService"
          label={IsGermanShoreShow ? "Ich stimme den Nutzungsbedingungen und den Teilnahmebedingungen zu." : "Ich habe die AGB gelesen."}
          component={SemanticFormField}
          as={Form.Checkbox}
          validate={getValidations(true)}
        />
      </Form>
    );
  }
}

export default reduxForm({ destroyOnUnmount: false })(TermsOfService);



// WEBPACK FOOTER //
// ./src/components/TermsOfService.js